import React from 'react';
import './_kpiCard.scss';

const KPICard = ({ title, value, subtitle, icon, color = 'primary', onClick }) => {
  return (
    <div className={`kpi-card kpi-card--${color}`} onClick={onClick}>
      <div className="kpi-card__content">
        <div className="kpi-card__header">
          <h3 className="kpi-card__title">{title}</h3>
          {icon && <div className="kpi-card__icon">{icon}</div>}
        </div>
        <div className="kpi-card__value">{value}</div>
        {subtitle && <div className="kpi-card__subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default KPICard;
